import api from "../..";
import type { CourseDetail, PatchCourseParams } from "./types";
import type { ApiResponse } from "../../types";

export const patchCourse = async ({ slugOrId, body }: PatchCourseParams): Promise<boolean> => {

  return await api.patch<ApiResponse<CourseDetail>>(`/course/${slugOrId}/`, body)
  .then(() => true)
  .catch(() => false);
};